//* Libraries imports
import z from "zod";

// Schema for individual criteria (C1-C5)
const criteriaSchema = z.object({
  nota: z.number().min(0).max(10),
  justificativa: z.string(),
});

// Extended correction schema with criteria C1-C5
const extendedCorrecaoSchema = z.object({
  nota_total: z.number(),
  foi_corrigida: z.boolean(),
  comentario_geral: z.string(),
  c1: criteriaSchema,
  c2: criteriaSchema,
  c3: criteriaSchema,
  c4: criteriaSchema,
  c5: criteriaSchema,
});

// Extended full result schema with enhanced dissertation correction
export const fullResultExtended = z.object({
  questao: z.object({
    id: z.number(),
    name: z.string(),
    type_questao: z.literal("dissertativa"),
    categoria: z.object({
      name: z.string(),
    }),
    resposta_estudante: z.string(),
    tipo_resposta: z.string(),
    correcao_dissertativa: extendedCorrecaoSchema,
  }),
});

// Export types
export type FullResultExtended = z.infer<typeof fullResultExtended>;
export type CriteriaSchema = z.infer<typeof criteriaSchema>;
export type ExtendedCorrecaoSchema = z.infer<typeof extendedCorrecaoSchema>;
